import Popup from './Popup'

export default Popup



// WEBPACK FOOTER //
// ./src/shared/components/organisms/Popup/index.js